import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';

export const PractitionerContext = createContext({});

export const Provider = (props) => {
  const {children} = props;

  const [selectedPractitioner, setSelectedPractitioner] = useState(null);
  const [reloading, setReloading] = useState(false);

  const practitionerContext = {
    selectedPractitioner,
    setSelectedPractitioner,
    reloading,
    setReloading,
  };

  return (
    <PractitionerContext.Provider value={practitionerContext}>
      {children}
    </PractitionerContext.Provider>
  );
};

export const {Consumer} = PractitionerContext;

Provider.propTypes = {
  children: PropTypes.any,
};
